import { View } from 'react-native'
import { useTranslation } from 'react-i18next'
import TextPaper from '@ui/elements/TextPaper'
import { useConfirmCustomer } from '@user/customer/confirmation/useConfirmCustomer'
import { useCustomerPolicies } from './useCustomerPolicies'
import PolicyRow from './PolicyRow'

interface Props {
  onPress: () => void
}

export default function PoliciesSection({ onPress }: Props) {
  const { t } = useTranslation(['ui', 'modals', 'deals-modals'])
  const { policies, isPolicyAccepted } = useCustomerPolicies()
  const { needsPolicies, getDetailStatus } = useConfirmCustomer()

  const hasAnyAccepted = policies.some((policy) =>
    isPolicyAccepted(policy.key, policy.revision)
  )
  const status = getDetailStatus({
    hasData: hasAnyAccepted,
    isValid: !needsPolicies,
    section: 'policies',
  })

  return (
    <TextPaper
      onPress={onPress}
      icon="license"
      label={t('modals:policies.title')}
      status={status}
    >
      {status !== 'empty' && (
        <View className="gap-2">
          {policies.map((policy) => (
            <PolicyRow
              key={policy.key}
              accepted={isPolicyAccepted(policy.key, policy.revision)}
              label={t(`deals-modals:policies.${policy.key}.title`)}
            />
          ))}
        </View>
      )}
    </TextPaper>
  )
}
